module.exports = new __parcel__URL__("twitter.da090011.svg").toString();